import {
  FORCE_SEO_LANDING,
  NEARBY_TRAINER_COUNT,
} from '@rover/react-lib/src/pages/training/constants/params';
import getUserAgentFlags from '@rover/shared/js/utils/getUserAgentFlags';
import { referrerIsRover } from '@rover/shared/js/utils/referrer';

/**
 * We work with the useLocationContext().search string on the frontend and
 * the req.query object in the prefetch on the backend.
 */
const getParam = (params: string | Record<string, unknown>, paramName: string): unknown => {
  if (typeof params === 'string') {
    return new URLSearchParams(params).get(paramName);
  }
  return params[paramName];
};

export const parseNearbyTrainerCountQueryParam = (
  params: string | Record<string, unknown>
): number | null => {
  const nearbyTrainerCountQueryParam = getParam(params, NEARBY_TRAINER_COUNT);

  if (!nearbyTrainerCountQueryParam) {
    return null;
  }

  return Number(nearbyTrainerCountQueryParam);
};

export const getShouldUseNearbyTrainerCountQueryParam = (
  nearbyTrainerCountQueryParam: number | null
): boolean => {
  const { isDesktop } = getUserAgentFlags();

  return (
    !isDesktop &&
    referrerIsRover() &&
    nearbyTrainerCountQueryParam !== null &&
    nearbyTrainerCountQueryParam > 0
  );
};

export const parseForceSeoLandingQueryParam = (
  params: string | Record<string, unknown>
): boolean => {
  const forceSeoLandingQueryParam = getParam(params, FORCE_SEO_LANDING);
  return forceSeoLandingQueryParam === 'true';
};

export const getShouldFetchNearbyTrainerCounts = (
  shouldUseNearbyTrainerCountQueryParam: boolean,
  forceSeoLanding?: boolean
): boolean => {
  if (shouldUseNearbyTrainerCountQueryParam) {
    return false;
  }

  if (forceSeoLanding) {
    return true;
  }

  return !referrerIsRover();
};

/**
 * Consolidates the calling of the functions above into a single util in order to
 * keep this page's prefetch function clean.
 */
export const getShouldPrefetchNearbyTrainerCounts = (params: Record<string, unknown>): boolean => {
  const nearbyTrainerCountQueryParam = parseNearbyTrainerCountQueryParam(params);
  const shouldUseNearbyTrainerCountQueryParam = getShouldUseNearbyTrainerCountQueryParam(
    nearbyTrainerCountQueryParam
  );
  const forceSeoLanding = parseForceSeoLandingQueryParam(params);
  return getShouldFetchNearbyTrainerCounts(shouldUseNearbyTrainerCountQueryParam, forceSeoLanding);
};
